














import { Vue, Component, Prop } from 'vue-property-decorator'
import { ICampaign } from '../../../../api_interface'
import { i18nTranslate } from '../../../../../i18n'

@Component
export default class extends Vue {
  @Prop({ required: true })
  begin!: boolean

  @Prop({ required: true })
  campaign!: ICampaign

  get name() {
    return i18nTranslate(this.campaign.name)
  }
}
